

<!-- Search field -->
<mat-form-field appearance="outline" style="width: 100%;">
  <mat-icon matIconPrefix>search</mat-icon>
  <mat-label style="font-size: 1rem;"><span>{{ 'SearchGroups' | translate:locale.language }}</span></mat-label>
  <input matInput ="text" id="qa-search-groups" [formControl]="groupSearchControl" [matAutocomplete]="autoGroup" />
  <mat-spinner matIconSuffix *ngIf="searchInProgress" diameter="20" class="search-spinner"></mat-spinner>
  <button *ngIf="groupSearchControl.value && !searchInProgress" matIconSuffix mat-icon-button [attr.aria-label]="'Clear' | translate:locale.language" (click)="resetSearch()">
    <mat-icon>close</mat-icon>
  </button>

  <mat-autocomplete #autoGroup="matAutocomplete" (optionSelected)="groupSelected($event.option.value)">
    <mat-option *ngFor="let result of searchResults" [value]="result">{{ result.name }}</mat-option>
  </mat-autocomplete>
</mat-form-field>
<div id="group-tree">
  <!-- Loading Spinner -->
  <div *ngIf="!topGroups || !groupsReady" style="padding: 48px;">
    <app-loading></app-loading>
  </div>
  <div class="tree-wrapper" [hidden]="!topGroups">
    <div *ngIf="groupsReady && topGroups.length === 0" class="empty-groups">{{ 'Groups.NoGroupsFound' | translate:locale.language }}</div>

    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
      <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding matTreeNodePaddingIndent="20px" (click)="groupSelected(node)" [class.selected]="node.id === selectedGroup?.id"
        (keydown.enter)="groupSelected(node)" (keydown.space)="$event.preventDefault(); groupSelected(node)" tabindex="0">
        <button mat-icon-button matTreeNodeToggle (keydown.enter)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()"
          [attr.aria-label]="(treeControl.isExpanded(node) ? 'Collapse ' : 'Expand ') + node.name">
          <mat-icon>{{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}</mat-icon>
        </button>
        <mat-icon class="with-text">folder</mat-icon>
        {{ node.name }}
        <mat-progress-spinner *ngIf="node.isLoading" mode="indeterminate" diameter="20" style="margin-left: 0.25rem"></mat-progress-spinner>
      </mat-tree-node>

      <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding matTreeNodePaddingIndent="20px" (click)="groupSelected(node)" [class.selected]="node.id === selectedGroup?.id"
        (keydown.enter)="groupSelected(node)" (keydown.space)="$event.preventDefault(); groupSelected(node)" tabindex="0">
        <!-- Adding an empty span to match the indentation for expandable nodes -->
        <span style="width: 40px;"></span>
        <mat-icon class="with-text">folder</mat-icon>
        {{ node.name }}
      </mat-tree-node>
    </mat-tree>
  </div>
</div>